import { createMachine } from 'xstate'

export const STATES = {
  LOAD_SUCCESS: 'LOAD_SUCCESS',
  CREATING: 'CREATING',
  CREATE_ERROR: 'CREATE_ERROR',
  CREATE_SUCCESS: 'CREATE_SUCCESS',
  GETTING_PRICES: 'GETTING_PRICES',
}

export const TRANSITIONS = {
  onCreate: 'onCreate',
  onCreateError: 'onCreateError',
  onCreateSuccess: 'onCreateSuccess',
  onGetPrices: 'onGetPrices',
  onGetPricesResult: 'onGetPricesResult',
}

export default createMachine({
  id: 'CottageContactWhatsAppPageForm',
  initial: STATES.LOAD_SUCCESS,
  states: {
    [STATES.LOAD_SUCCESS]: {
      on: {
        [TRANSITIONS.onCreate]: STATES.CREATING,
        [TRANSITIONS.onGetPrices]: STATES.GETTING_PRICES,
      },
    },
    [STATES.CREATING]: {
      on: {
        [TRANSITIONS.onCreateError]: STATES.CREATE_ERROR,
        [TRANSITIONS.onCreateSuccess]: STATES.CREATE_SUCCESS,
      },
    },
    [STATES.CREATE_ERROR]: {
      on: { [TRANSITIONS.onCreate]: STATES.CREATING },
    },
    [STATES.CREATE_SUCCESS]: {
      type: 'final',
    },

    [STATES.GETTING_PRICES]: {
      on: {
        [TRANSITIONS.onGetPricesResult]: STATES.LOAD_SUCCESS,
      },
    },
  },
  predictableActionArguments: true,
})
